import React, { useState, useCallback } from 'react';
import { Formik, Form, Field } from 'formik';
import { MenuItem, Button, TextField, Autocomplete, CircularProgress } from '@mui/material';
import * as Yup from 'yup';
import { TrainingRequests } from 'requests/TrainingRequests';
import debounce from 'lodash.debounce';
import { useSelector } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';

// Validation schema using Yup
const validationSchema = Yup.object({
  employee: Yup.array()
    .min(1, 'Please select at least one employee')
    .required('Please select an employee'),
  region: Yup.array().required('Please select a region'),
});

const AddTrainerForm = ({
  employee: propsEmp,
  region: propsRegion,
  disabled = [],
  closeModal,
  trigger,
}) => {
  const [employees, setEmployees] = useState([]);
  const [loadingEmployees, setLoadingEmployees] = useState(false);
  const {
    data: { regions },
    loading: regionsLoading,
  } = useSelector((state) => state.trainersSlice);
  console.log('callbacks', propsEmp);
  // Debounced function to fetch employees
  const fetchEmployees = useCallback(
    debounce(async (searchTerm) => {
      if (searchTerm) {
        setLoadingEmployees(true);
        try {
          const results = await TrainingRequests.searchEmployees(searchTerm);
          setEmployees(results || []);
        } catch (error) {
          console.error('Error fetching employees:', error);
        } finally {
          setLoadingEmployees(false);
        }
      } else {
        setEmployees([]);
      }
    }, 200),
    []
  );

  const handleSearchChange = (event) => {
    fetchEmployees(event.target.value);
  };

  const handleSubmit = async (values) => {
    console.log('Form Submitted:', values);
    // let tempRegionStructure = {
    //   regionId: values.region.split("-")[0],
    //   regionName: values.region.split("-")[1],
    // };
    // values["regionIdsMapped"] = [values.region.split("-")[0]];
    let regionIds = [];
    values.region.forEach((elem) => {
      regionIds.push(elem.regionId);
    });
    values['regionIdsMapped'] = regionIds;
    try {
      await TrainingRequests.createTrainee(values);
      toast.success('Trainee Created ..', {
        theme: 'colored',
      });
      if (trigger) {
        trigger();
      }
      // Refresh the page after successful update
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } catch (error) {
      // Show error message toast
      toast.error(`Failed to create Trainees: ${error.message}`, {
        theme: 'colored',
      });
    }
    if (closeModal) {
      closeModal();
    }
  };

  return (
    <>
      <Formik
        initialValues={{
          employee: propsEmp && propsEmp.length > 0 ? propsEmp : [],
          region: propsRegion ?? '',
          isTrainer: true,
        }}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ errors, touched, values, setFieldValue }) => (
          <Form>
            {/* Employee Autocomplete */}
            {console.log('values', values)}
            <Autocomplete
              multiple
              disabled={disabled.includes('employee')}
              size="small"
              value={values.employee}
              options={employees}
              getOptionLabel={(option) => `${option.employeeId}-${option.employeeName}`}
              onChange={(event, newValue) => setFieldValue('employee', newValue)}
              filterSelectedOptions
              loading={loadingEmployees}
              isOptionEqualToValue={(option, value) => option.employeeId === value.employeeId}
              renderInput={(params) => (
                <TextField
                  {...params}
                  size="small"
                  placeholder="Search by Employee ID or Name"
                  error={touched.employee && !!errors.employee}
                  helperText={touched.employee && errors.employee}
                  onChange={handleSearchChange}
                  disabled={disabled.includes('employee')}
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <>
                        {loadingEmployees ? <CircularProgress size={20} /> : null}
                        {params.InputProps.endAdornment}
                      </>
                    ),
                  }}
                />
              )}
            />

            {/* Region Dropdown */}
            {/* <Field
              name="region"
              as={TextField}
              select
              disabled={disabled.includes("region")}
              label="Select Region"
              fullWidth
              margin="normal"
              error={touched.region && !!errors.region}
              helperText={touched.region && errors.region}
            >
              {regions.map((region) => (
                <MenuItem key={region.regionId} value={`${region.regionId}-${region.regionName}`}>
                  {`${region.regionId}-${region.regionName}`}
                </MenuItem>
              ))}
            </Field> */}

            <Autocomplete
              multiple
              disabled={disabled.includes('region')}
              size="small"
              value={values.region}
              options={regions}
              getOptionLabel={(option) => `${option.regionId}-${option.regionName}`}
              onChange={(event, newValue) => setFieldValue('region', newValue)}
              filterSelectedOptions
              loading={regionsLoading}
              isOptionEqualToValue={(option, value) => option.regionId === value.regionId}
              renderInput={(params) => (
                <TextField
                  {...params}
                  size="small"
                  placeholder="Select Regions"
                  error={touched.region && !!errors.region}
                  helperText={touched.region && errors.region}
                  disabled={disabled.includes('region')}
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <>
                        {regionsLoading ? <CircularProgress size={20} /> : null}
                        {params.InputProps.endAdornment}
                      </>
                    ),
                  }}
                />
              )}
            />
            {/* Submit Button */}
            <Button type="submit" variant="contained" color="primary" fullWidth sx={{ mt: 2 }}>
              Submit
            </Button>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default AddTrainerForm;
